import * as React from 'react';

function SvgNoTerms(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 215 190" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M24.926 183.635c6.071 6.077 153.17 9.567 167.133 0 9.428-6.46 18.184-73.658 20.622-86.838 2.438-13.18 1.835-27.094.863-40.77-.69-9.718-1.781-20.104-6.921-27.741C201.187 20.21 192.059 0 164 1c-28.06 1-38.979 26.09-48.919 29-6.771 1.98-9.904 33.464-48.081 29.008-8.136-.95-49.638 18.38-58.916 35.53-12.765 23.6-11.268 60.962 16.842 89.097z"
          fill="#E2F4F2"
        />
        <path
          d="M42 168s-.904-27.285-15.389-42.703c-6.08-6.47-10.073-14.686-11.13-23.578A70.89 70.89 0 0115.141 89"
          stroke="#4C4C4C"
        />
        <path
          d="M6.307 79.777C7.355 82.878 16.12 90 16.12 90s2.686-10.85 1.637-13.948c-.678-2.005-2.396-3.503-4.507-3.93a6.104 6.104 0 00-5.725 1.861 5.826 5.826 0 00-1.218 5.792v.002zM2.405 99.651C4.954 101.691 16 103 16 103s-3.682-10.514-6.231-12.55a5.896 5.896 0 00-9.713 3.639 5.9 5.9 0 002.349 5.562zm10.504 28.313c3.142.485 13.091-4.048 13.091-4.048s-8.267-7.366-11.41-7.851c-2.031-.315-4.07.53-5.346 2.215-1.276 1.685-1.596 3.955-.84 5.955.755 2 2.473 3.426 4.505 3.74v-.011zm12.167 20.8C28.176 149.801 39 147.08 39 147.08s-7.15-8.74-10.25-9.776c-3.098-1.04-6.435.683-7.453 3.848-1.018 3.165.668 6.574 3.767 7.613h.012z"
          fill="#38B2A6"
          fillRule="nonzero"
        />
        <path
          d="M27.346 99.538C25.844 102.398 16.251 108 16.251 108s-.871-10.992.631-13.856a5.896 5.896 0 014.968-3.138 5.906 5.906 0 015.227 2.695 5.796 5.796 0 01.258 5.834l.011.003zm14.919 23.594C39.943 125.456 29 128 29 128s2.513-10.929 4.831-13.253a5.962 5.962 0 018.418-.016 5.928 5.928 0 01.016 8.398v.003zm10.58 25.067C51.015 150.791 41 155 41 155s.603-10.82 2.435-13.414a5.76 5.76 0 015.27-2.568 5.755 5.755 0 014.791 3.373 5.726 5.726 0 01-.662 5.811l.011-.003z"
          fill="#38B2A6"
          fillRule="nonzero"
        />
        <path
          d="M52.117 106.26c-.517 1.725.848 7.74.848 7.74s4.369-3.977 4.885-5.698c.517-1.723-.347-3.576-1.93-4.139-1.583-.563-3.286.378-3.803 2.1v-.002z"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M52.117 106.26c-.517 1.725.848 7.74.848 7.74s4.369-3.977 4.885-5.698c.517-1.723-.347-3.576-1.93-4.139-1.583-.563-3.286.378-3.803 2.1v-.002z"
          fill="#FFF"
          fillRule="nonzero"
          opacity={0.5}
        />
        <path fill="#4C4C4C" fillRule="nonzero" d="M55 190H31.003L25 154h36z" />
        <path
          fill="#000"
          fillRule="nonzero"
          opacity={0.1}
          d="M56.466 154l-5.533 33.64H31l.389 2.36h23.69L61 154z"
        />
        <path
          d="M58.152 34c-6.708.007-12.144 5.169-12.152 11.538v132.924c.008 6.37 5.444 11.53 12.152 11.538h102.696c6.708-.007 12.144-5.169 12.152-11.538V45.538c-.008-6.37-5.444-11.53-12.152-11.538H58.152z"
          fill="#63656A"
          fillRule="nonzero"
        />
        <rect fill="#FFF" fillRule="nonzero" x={55} y={42} width={109} height={139} rx={4} />
        <path
          fill="#38B2A6"
          fillRule="nonzero"
          d="M67 65h85v6H67zm0 14h85v6H67zm0 15h85v6H67zm0 15h85v6H67zm0 14h85v6H67zm0 15h85v6H67zm0 15h85v6H67z"
        />
        <path
          fill="#E2F4F2"
          fillRule="nonzero"
          d="M69.213 44.368l83.912-15.294 19.745 107.45-83.913 15.294z"
        />
        <path
          fill="#38B2A6"
          fillRule="nonzero"
          d="M83.722 61.629l61.973-11.296.745 4.055-61.973 11.295zM85.709 72.441l61.973-11.295.745 4.054-61.973 11.296zM87.696 83.254l61.973-11.296.745 4.055L88.44 87.309zM89.682 94.066l61.973-11.295.746 4.054-61.974 11.296zM91.668 104.878l61.973-11.294.745 4.055-61.973 11.294zM93.656 115.692l61.973-11.296.745 4.055-61.973 11.295zM95.643 126.504l61.973-11.295.745 4.054-61.973 11.296z"
        />
        <path
          d="M131.318 22.713h-10.146v-2.065c0-3.12-2.543-5.648-5.681-5.648h-10.982c-3.138 0-5.681 2.529-5.681 5.648v2.065H88.682a5.699 5.699 0 00-4.018 1.654A5.631 5.631 0 0083 28.361V44h54V28.36a5.631 5.631 0 00-1.664-3.993 5.699 5.699 0 00-4.018-1.654z"
          fill="#FCCD00"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default SvgNoTerms;
